import {SierraCanvas} from '../../classes/sierraCanvas';

/**
 * @name hasTransparency
 */
export const hasTransparency = (img: HTMLImageElement): boolean => {
  const canvas = new SierraCanvas(img.width, img.height);

  let utilisedPixelCount = 0;
  let alphaPixelCount = 0;

  canvas.drawImage(img, 0, 0);

  canvas.forEachPixel(({a}: Record<string, number>) => {
    utilisedPixelCount++;
    if (a < 255) {
      alphaPixelCount++;
    }
  });

  canvas.destroy();

  if (utilisedPixelCount && alphaPixelCount / utilisedPixelCount > 0.1) {
    return true;
  }

  return false;
};
